import React, { Fragment, useState } from "react"
import styles from "./no-delivery-boy.scss"
import SliderWrapper from "jd-library/SliderWrapper"
import Button from "jd-library/Button"
import ImageIcons from "jd-library/ImageIcons"
import historyHandler from "jd-library/historyHandler"
// import BackDrop from '../BackDrop'
import { connect } from "react-redux"
import bgstyles from "../deliveryboy.scss"

/**
 * Returns No Delivery Boy Page
 * @returns {any}
 */
function NoDeliveryBoy(props) {
  const [show, toggleSlider] = useState(false)
  const [innerSlider, toggleInnerSlider] = useState(false)
  const leftIcons = [
    {
      className: "icon-key-left",
      onClick: () => {
        props.apkback ? props.apkback() : historyHandler.closeCurrent()
      },
    },
  ]

  const rightIcons = [
    {
      className: "icon-HDRcross",
      onClick: () => {
        props.apkback ? props.apkback() : historyHandler.closeCurrent()
      },
    },
  ]
  return (
    <>
    <SliderWrapper
      sliderClassName={styles["no-delivery-boy-landing-page"]}
      header={{
        heading: "Delivery Boy",
        leftIcons: props.isMobile ? leftIcons : [],
        rightIcons: !props.isMobile ? rightIcons : [],
      }}
      onHidden={() => {
        //toggleSlider(false)
        historyHandler.closeCurrent()
        props.apkback ? props.apkback() : window.history.back()
      }}
    >
      <div className={styles["no-delivery-boy-container"]}>
        <div className={styles["no-delivery-boy"]}>
          <img src={ImageIcons.EMPTY_DELIVERY} />
          <div className={styles["title"]}>Add Your Delivery Boy</div>
          <p className={styles["desc"]}>
            You can Create Your Own Delivery Boy and Assign Your Order for
            Delivery
          </p>
          <Button className={styles["add-btn"]} size="lg" onClick={() => props.showAddDeliveryBoy('2','')}>
            <i className="icon-plus"></i>
            <span>Add delivery boy</span>
          </Button>
        </div>
      </div>
    </SliderWrapper>
    <div 
      className={bgstyles[props.isMobile?"bg-none":"bg-jd"]}
      style={{
      marginLeft: "80px", height: "500px"
    }}>
    </div>
    {/* {BackDrop} */}
    </>
    
  )
}
const mapStateToProps = (state, props) => {
  return {
    ...props,
    isMobile: state.library.deviceData.isMobile,
    session: state.session,
  }
}
export default connect(mapStateToProps, {})(NoDeliveryBoy)